// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"a6-z"};